<div class="login-content">
  <div class="login-card">
    <div class="img-agent prima-logo">
      <img src="assets/img/prima-logo.png">
    </div>
    <div class="img-agent prima-text">
      Přihlášení do administrace
    </div>
    <mat-card appearance="outlined">
      <mat-card-content>
        <form [formGroup]="admLoginForm">
          <mat-form-field class="inp-email">
            <mat-label>Username:</mat-label>
            <input formControlName="username" name="username" type="text" matInput (keyup.enter)="login()">
          </mat-form-field>
          <mat-form-field class="inp-email">
            <mat-label>Password:</mat-label>
            <input formControlName="password" name="password" type="password" matInput (keyup.enter)="login()">
          </mat-form-field>
          <button type="submit" [disabled]="!admLoginForm.valid" mat-flat-button color="primary" class="btn-email" (click)="login()">
            @if (disableInputs && loading) {
              <ng-container>
                <mat-spinner [diameter]="20" slot="start" color="primary"></mat-spinner>
              </ng-container>
            }
            @else if (disableInputs && !loading && !errorMsg) {
              <ng-container>
                <mat-icon slot="start">check</mat-icon>
                Úspěšně přihlášeno
              </ng-container>
            }
            @else if (disableInputs && !loading && errorMsg) {
              <ng-container>
                <mat-icon slot="start">close</mat-icon>
                Chyba
              </ng-container>
            }
            @else {
              <ng-container>
                <mat-icon slot="start">login</mat-icon>
                Přihlásit
              </ng-container>
            }
          </button>
        </form>
        @if (errorMsg) {
          <small style="color:red"><mat-icon slot="start">error</mat-icon> Přihlášení se nepodařilo z následujícího důvodu:<br><code>{{errorMsg}}</code></small>
        }
      </mat-card-content>
    </mat-card>
  </div>
  <button style="right: 5px;bottom: 5px;position: absolute;" color="secondary" mat-icon-button [routerLink]="['/login']"><mat-icon slot="start">person</mat-icon></button>
</div>
